// functions for getting chapter, section, and code objects
// needs the parent to have an array of codes (with the code as key)
// and a meta array with 'chapters' and 'section' keys
export default {
  props: {},
  data: function () {
    return {};
  },
  computed: {
    searchedObject: function () {
      if (!this.meta?.searchObj) return null;
      return this.icdObjForKey(this.meta.searchObj);
    },
  },
  methods: {
    justTheNumber(key) {
      return key.replace(/^\D+[ ]/g, ""); // "Chapter 7" => "7"
    },
    chapterObjForKey(key) {
      let num = this.justTheNumber(key);
      return this.meta.chapters[num];
    },
    sectionObjForKey(key) {
      let num = this.justTheNumber(key);
      return this.meta.sections[num];
    },
    // key will be like "H00.1", "chapter 7", or "section 92"
    // returns either the meta.chapters[x], meta.sections[x], or codes[x]
    icdObjForKey(key) {
      let rtn = null;
      if (key.includes("chapter")) rtn = this.chapterObjForKey(key);
      if (key.includes("section")) rtn = this.sectionObjForKey(key);
      if (rtn == null && key) rtn = this.codes[key];
      return rtn;
    },
    keyValueForObj(obj, key) {
      let rtn = null;
      if (obj && key && obj[key]) rtn = obj[key];
      return rtn;
    },
  },
};
